export const HIDEINFO_EMAIL = 'email'
export const HIDEINFO_TEL = 'tel'

export const hideInfo = (str, type) => {
    let infoString = str
    if (str !== "" && str !== undefined) {
        if (type === HIDEINFO_EMAIL) {
            return str.split('@').map((i, index) => {
                if (index === 0) {
                    const ln = Math.min(i.length, 3)
                    return i.substring(0, ln) + "****"
                }

                return i
            }).join("@")
        } else if (type === HIDEINFO_TEL) {
            const ln = str.length
            return str.split("").map((i, index) => {
                if (ln === 10) { // tel number
                    return (index >= 3 && index <= 7) ? '*' : i
                }
                return index > 2 ? i : '*'
            })
        }
    }

    return infoString
}